const sendNotyAlert = (type, message) => {
  if (window.noty) {
    window.parent.noty({
      text: message,
      layout: type === 'fail' ? 'top' : 'topRight',
      type: type === 'fail' ? 'error' : type,
      dismissQueue: true,
      modal: false,
      force: true,
      animation: {
        open: {
          height: 'toggle'
        },
        close: {
          height: 'toggle'
        },
        easing: 'swing',
        speed: 500 // opening & closing animation speed

      },
      timeout: type === 'error' ? 50000 : 5000,
      closewith: ['hover', 'click']
    });
  } else {
    // eslint-disable-next-line no-console
    console.log(`${type}: ${message}`);
  }
};

export default sendNotyAlert;